import React from 'react';
import Link from 'next/link';
import Image from 'next/image';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import styles from '../../styles/compare/OfferDetails.module.scss';
import * as gtag from '../../cookie/lib/gtag';

const PaydayLoanDetails = (props) => {
    const {show, handleClose, details, applyParams, product} = props;

    let provider  = details.showLogo ? 
                    <Image 
                        src={details.providerLogo} 
                        height={details.logoSize.height} 
                        width={details.logoSize.width}
                    /> 
                    :
                    <p>{details.provider}</p>;

    let relOpennerTag;
    if (details.hasOwnProperty('apply')) {
        relOpennerTag = details.apply.indexOf(` ${process.env.NEXT_PUBLIC_SITE_URL} `) > -1 ? '' : 'noopener';
    } else {
        relOpennerTag = '';
    }

    const onApply = () => {
        if (window.location.hostname.indexOf('conso.ro')>1) {
            gtag.event('Apply', {
                provider: details.provider,
                product: product,
            });
        } else {
            console.log("beta");
        }
        handleClose();
    }

    return (
        <Modal show={show} onHide={handleClose} dialogClassName={styles.modal90w}>
            <Modal.Header closeButton>
                <Modal.Title>             
                    {provider}
                    <p className={`${styles.productName} text-muted mb-0`}>{details.product}</p>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
             {details.hasOwnProperty('apply') && 
                <Link
                    href={ details.apply.indexOf(`${process.env.NEXT_PUBLIC_SITE_URL}`) > -1 ? 
                            `${details.apply}${applyParams.length>0 ? '?'+ applyParams : ''}`
                            : 
                            details.apply
                        }
                    onClick={onApply}
                    rel={relOpennerTag}
                    target={details.apply.indexOf(`${process.env.NEXT_PUBLIC_SITE_URL}`) > -1 ? '_self' : '_blank'}
                    title="Solicită oferta"
                    className="btn btn-primary mt-2 mb-3">
                    Solicită oferta
                                            <FontAwesomeIcon className="ms-2" icon={faChevronRight} height="16" width="16" />

                </Link>    
                } 

               

                <Row className={styles.endSection}>
                    <Col xs="12" className={styles.productSection}>
                        Cost total
                    </Col>
                    <Col xs="12" md="5" className={styles.key}>
                        DAE
                    </Col>
                    <Col xs="12" md="7" className={styles.info}>
                        {Intl.NumberFormat('fr', {maximumFractionDigits: 2}).format(details.apr)} %
                    </Col>  

                    <Col xs="12" md="5" className={styles.key}>
                        Cost total
                    </Col>
                    <Col xs="12" md="7" className={`${styles.info}`}>
                         {Intl.NumberFormat('fr', {maximumFractionDigits: 0}).format(details.totalCost)} lei
                    </Col>

                    <Col xs="12" md="5" className={styles.key}>
                        Suma de rambursat
                    </Col>
                    <Col xs="12" md="7" className={`${styles.info}`}>
                         {Intl.NumberFormat('fr', {maximumFractionDigits: 0}).format(details.totalAmount)} lei
                    </Col>
                
                </Row>

                <Row className={styles.endSection}>
                    <Col xs="12" className={styles.productSection}>
                        Dobândă și comisioane
                    </Col>
                    <Col xs="12" md="5" className={styles.key}>
                        Rata dobânzii
                    </Col>
                    <Col xs="12" md="7" className={styles.info}>
                    {Intl.NumberFormat('fr', {maximumFractionDigits: 2}).format(details.rate)}% pe zi
                    </Col> 
                    <Col xs="12" md="5" className={styles.key}>
                        Tip dobândă
                    </Col>
                    <Col xs="12" md="7" className={styles.info}>
                       {details.rateType}
                    </Col> 

                    <Col xs="12" md="5" className={styles.key}>
                        Comision 
                    </Col>
                    <Col xs="12" md="7" className={styles.info}>
                       {details.fee} lei
                    </Col>
                    <Col xs="12" md="5" className={styles.key}>
                        Comision prelungire credit
                    </Col>
                    <Col xs="12" md="7" className={styles.info}>
                       {details.rolloverFee}
                    </Col>
                    <Col xs="12" md="5" className={styles.key}>
                        Comision penalizare întârziere
                    </Col>
                    <Col xs="12" md="7" className={styles.info}>
                       {details.penaltyFee}
                    </Col>
                    
                </Row>

                <Row className={styles.endSection}>
                    <Col xs="12" className={styles.productSection}>
                        Eligibilitate
                    </Col>
                    <Col xs="12" md="5" className={styles.key}>
                        Vârsta minimă
                    </Col>
                    <Col xs="12" md="7" className={styles.info}>
                       {details.minAge}
                    </Col> 
                    <Col xs="12" md="5" className={styles.key}>
                        Venit minim
                    </Col>
                    <Col xs="12" md="7" className={styles.info}>
                       {details.minIncome}
                    </Col> 
                    <Col xs="12" md="5" className={styles.key}>
                        Alte condiții
                    </Col>
                    <Col xs="12" md="7" className={styles.info}>
                       {details.terms}
                    </Col> 
                </Row>

               

              

            </Modal.Body>
            <Modal.Footer className="justify-content-between" >  
                {details.hasOwnProperty('apply') && 
                <Link
                    href={ details.apply.indexOf(`${process.env.NEXT_PUBLIC_SITE_URL}`) > -1 ? 
                        `${details.apply}${applyParams.length>0 ? '?'+ applyParams : ''}`
                        : 
                        details.apply
                    }
                    onClick={onApply}
                    rel={relOpennerTag}
                    target={details.apply.indexOf(`${process.env.NEXT_PUBLIC_SITE_URL}`) > -1 ? '_self' : '_blank'}
                    title="Solicită oferta"
                    className="btn btn-primary mt-2 mb-3">
                    Solicită oferta
                                            <FontAwesomeIcon className="ms-2" icon={faChevronRight} height="16" width="16" />

                </Link>    
                } 

            
                <Button variant="outline-secondary" onClick={handleClose}>
                    Închide
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default PaydayLoanDetails;